import { render, staticRenderFns } from "./CourseDetail.vue?vue&type=template&id=ee4cbbec&scoped=true&"
import script from "./CourseDetail.vue?vue&type=script&lang=js&"
export * from "./CourseDetail.vue?vue&type=script&lang=js&"
import style0 from "./CourseDetail.vue?vue&type=style&index=0&id=ee4cbbec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee4cbbec",
  null
  
)

export default component.exports